import api from './api';

export interface QuestionnairePushRequest {
  questionnaireId: number;
  schoolIds?: number[];
  grades?: string[];
  classIds?: string[];
  academicYears?: string[];
  targetRoles: string[];
  startTime?: string;
  endTime?: string;
}

export interface QuestionnairePush {
  id: number;
  questionnaireId: number;
  questionnaireTitle: string;
  schoolIds?: number[];
  schoolNames?: string[];
  grades?: string[];
  classIds?: string[];
  classNames?: string[];
  academicYears?: string[];
  targetRoles: string[];
  startTime?: string;
  endTime?: string;
  status: string;
  statusDisplayName: string;
  createdByUserId: number;
  createdByUsername: string;
  createdAt: string;
  updatedAt: string;
}

export const pushService = {
  /**
   * 创建问卷推送
   */
  async createPush(data: QuestionnairePushRequest): Promise<QuestionnairePush> {
    const response = await api.post('/admin/questionnaire-pushes', data);
    return response.data.data;
  },

  /**
   * 获取问卷的推送列表
   */
  async getQuestionnairePushes(questionnaireId: number): Promise<QuestionnairePush[]> {
    const response = await api.get(`/admin/questionnaire-pushes/questionnaire/${questionnaireId}`);
    return response.data.data;
  },

  /**
   * 获取单个推送详情
   */
  async getPushDetail(pushId: number): Promise<QuestionnairePush> {
    const response = await api.get(`/admin/questionnaire-pushes/${pushId}`);
    return response.data.data;
  },

  /**
   * 获取所有活跃的推送
   */
  async getActivePushes(page: number = 0, size: number = 10) {
    const response = await api.get('/admin/questionnaire-pushes', {
      params: { page, size }
    });
    return response.data.data;
  },

  /**
   * 更新推送状态
   */
  async updatePushStatus(pushId: number, status: string): Promise<QuestionnairePush> {
    const response = await api.patch(`/admin/questionnaire-pushes/${pushId}/status`, null, {
      params: { status }
    });
    return response.data.data;
  },

  /**
   * 删除推送
   */
  async deletePush(pushId: number): Promise<void> {
    await api.delete(`/admin/questionnaire-pushes/${pushId}`);
  }
};
